import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IUpdateUsersGroupMembershipParams {
  userIds: string[];
  addToGroupIds: string[];
  removeFromGroupIds: string[];
}

export interface IUpdateUsersGroupMembershipResult extends IResult {
}

export class UpdateUsersGroupMembershipRequest extends Request<IUpdateUsersGroupMembershipParams, IUpdateUsersGroupMembershipResult> {
  constructor(params: IUpdateUsersGroupMembershipParams) {
    super('updateUsersGroupMembership', params);
  }
}
